export default __webpack_public_path__ + "static/media/Gwalior_Fort_-Gwalior_-Madhya_Pradesh_-IMG_1328.9d2319ba.jpg";